import EFPEM003CEBEU120 from './EFPEM-003CEBEU120.js';
import EF3PL00112EU from './EF3PL-00112EU.js';
import EFNPL00112UK from './EFNPL-00112UK.js';

export const EcoFlow = {
	'EFPEM-003CEBEU120': EFPEM003CEBEU120,
	'EF3PL-00112EU': EF3PL00112EU,
	'EFNPL-00112UK': EFNPL00112UK,
};
